// Decide how to render an MMS attachment given its MIME type.
// Mutli-media MMS can carry images, video clips, voice memos (audio/amr,
// audio/3gpp on many carriers), PDFs, vCards, etc. -- so we branch on the
// blob's real Content-Type rather than assuming everything is an image.
//
// The backend's media proxy (/api/messages/{sid}/media/{mediaId}) forwards
// the upstream Content-Type into the blob, so blob.type is trustworthy here.
//
// Returns one of:
//   'image'  -> inline <img> preview + click-to-open
//   'video'  -> inline <video controls>
//   'audio'  -> inline <audio controls> (voice memo)
//   'other'  -> generic "tap to open" link (pdf, vcard, unknown, empty)
export function resolveMediaRenderType(mime) {
  const t = String(mime || '').trim().toLowerCase();
  if (t.startsWith('image/')) return 'image';
  if (t.startsWith('video/')) return 'video';
  if (t.startsWith('audio/')) return 'audio';
  return 'other';
}
